import { setToken, getToken } from '@/utils/auth.js'
// state数据
const state = {
  // token数据从本地cookie中读取
  token: getToken(),
  showLogin: false, // 登录弹窗
  showUser: true // 展示用户信息
}

// mutations方法
const mutations = {
  // 设置token
  SET_TOKEN: (state, value) => {
    state.token = value
    setToken(value)
  }
}

// actions操作
const actions = {
  setUserToken ({ commit }, data) {
    commit('SET_TOKEN', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
